<template>
  <v-container fill-height>
    <v-row
      align="center"
      justify="center"
      :no-gutters="$vuetify.breakpoint.smAndDown"
      style="margin-top: -100px;"
    >
      <v-col cols="12" align="center">
        <v-progress-circular
          indeterminate
          color="primary"
          size="72"
        />
      </v-col>
      <v-col cols="12" align="center">
        <div class="headline">
          If it cannot be measured, it cannot be managed.
        </div>
        <div class="title">
          Loading dashboard configurations
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'DashboardLoading',
};
</script>
